import React from 'react';
import { useTranslation } from 'react-i18next';
import { ISharedUser } from 'types/IEquipmentEntry';
import { Card } from '@progress/kendo-react-layout';
import { Avatar } from 'app/components/Avatar';

interface ISharedWithRow {
  user: ISharedUser;
  isMobile: boolean;
  onClick: () => void;
}

function SharedWithRow({ user, isMobile, onClick }: ISharedWithRow) {
  const { t } = useTranslation();
  const equipmentCount = user.sharedEquipments.length;
  const fleetsCount = user.sharedFleets.length;

  const fleetText =
    fleetsCount > 1 || fleetsCount === 0
      ? `${t('access_sharing.shared_with.card.fleets_plural', {
          numberOfFleets: fleetsCount,
        })}`
      : `${t('access_sharing.shared_with.card.fleets_singular', {
          numberOfFleets: fleetsCount,
        })}`;

  const equipmentText = isMobile
    ? `${t('access_sharing.shared_with.card.equipment_plural', {
        numberOfEquipment: equipmentCount,
      })}`
    : equipmentCount > 1 || equipmentCount === 0
    ? `${t('number_of_equipment', {
        numberOfEquipment: equipmentCount,
      })}`
    : t('access_sharing.shared_with.card.equipment_singular', {
        numberOfEquipment: equipmentCount,
      });

  return (
    <>
      {!isMobile ? (
        <>
          <div
            className="access-sharing-table-row shared-with min-w-0"
            onClick={onClick}
            style={{ cursor: 'pointer' }}
          >
            <div className="min-w-0">
              <div className="picture-and-description shared-with min-w-0">
                <Avatar email={user.email} firstName={user.displayName} />
                <div className="min-w-0">
                  <div className="equipment-nickname ellipsis-2-lines">
                    {user.displayName}
                  </div>
                  <div className="ellipsis">{user.email}</div>
                </div>
              </div>
            </div>
            <div className="shared-with-access-to">
              {equipmentText}, {fleetText}
            </div>
            <div className="shared-with-access-to">
              {[
                ...user.sharedEquipments.map(
                  equipment => equipment.sharedItemDetails.sharedItemLabel,
                ),
                ...user.sharedFleets.map(
                  fleet => fleet.sharedItemDetails.sharedItemLabel,
                ),
              ].join(', ')}
            </div>
          </div>
        </>
      ) : (
        <div
          className="access-sharing-table-card shared-with"
          onClick={onClick}
        >
          <div className="row picture-and-description shared-with">
            <Avatar email={user.email} firstName={user.displayName} />
            <div className="col min-w-0">
              <div className="equipment-nickname ellipsis-2-lines">
                {user.displayName}
              </div>
              <div className="ellipsis">{user.email}</div>
            </div>
          </div>
          <div className="equipment-list-details">
            <div className="row-4">
              <div className="col-xxs-12">
                <Card className="access-sharing-equipment-details">
                  <div className="row">
                    <div className="colored-info">{t('access_to')}</div>
                  </div>

                  <div className="row">
                    <div className="col-xxs-4">
                      <span className="bolded-info">{equipmentText}</span>
                    </div>
                    <div className="col-xxs-8">
                      <span>
                        {user.sharedEquipments
                          .map(
                            equipment =>
                              equipment.sharedItemDetails.sharedItemLabel,
                          )
                          .join(', ')}
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xxs-4">
                      <span className="bolded-info">{fleetText}</span>
                    </div>
                    <div className="col-xxs-8">
                      <span>
                        {user.sharedFleets
                          .map(fleet => fleet.sharedItemDetails.sharedItemLabel)
                          .join(', ')}
                      </span>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SharedWithRow;
